import { FormProvider, useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

import { Grid, Stack } from '@mui/material';

import { Page } from '@/components';
import { cfsTabs } from '@/constants';
import { BottomTabBar, TabLayout } from '@/layouts/TabLayout';
import { ICFSForm } from '@/models';

import { CFSForm } from './components/CFSForm';
import CFSHeader from './components/CFSHeader';
import { CFSMap } from './components/CFSMap';
import { LiveInformation } from './components/LiveInformation';
import { UnitShiftList } from './components/UnitShiftList';
import { cfsDefaultValues, cfs } from './data';
import { CFSEditRoot } from './styles';

const CFSCareLinkDetail = () => {
  const { pathname } = useLocation();
  const paths = pathname.split('/');

  const formMethods = useForm<ICFSForm>({
    defaultValues: cfsDefaultValues,
    mode: 'onChange',
  });

  return (
    <Page
      title={cfs ? `${cfs?.number} detail page` : 'Loading ...'}
      style={{ height: '100vh' }}
    >
      <CFSEditRoot>
        <FormProvider {...formMethods}>
          <Grid columnSpacing={2} container>
            <Grid item xs={12} lg={8}>
              <Stack justifyContent="space-between" rowGap={2.5}>
                <CFSHeader />

                <Stack className="active-cfs-content">
                  <Grid spacing={2} container sx={{ flex: 1 }}>
                    <Grid item xs={12} lg={6}>
                      <CFSForm />
                    </Grid>

                    <Grid item xs={12} lg={6} className="active-cfs-widgets">
                      <Stack spacing={2} sx={{ height: '100%' }}>
                        <CFSMap />
                        <LiveInformation />
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
              <TabLayout
                tabLinks={[
                  ...cfsTabs
                    .filter((tab) => !tab.hidden)
                    .map((tab, idx) => ({
                      label: tab.label,
                      path: `carelink?${idx}`,
                    })),
                  {
                    label: 'CareLink',
                    path: 'carelink',
                  },
                ]}
                basePath={`/${paths[1]}/${paths[2]}`}
                style={{ width: 'calc(100% - 40px)', position: 'absolute' }}
              >
                <BottomTabBar
                  additionalInfo={[]}
                  isQuickView={true}
                  cfsId="carelink"
                />
              </TabLayout>
            </Grid>

            <Grid item xs={12} lg={4} className="mapbox-unit-list">
              <Stack className="unit-list">
                <UnitShiftList />
              </Stack>
            </Grid>
          </Grid>
        </FormProvider>
      </CFSEditRoot>
    </Page>
  );
};

export default CFSCareLinkDetail;
